import { render, staticRenderFns } from "./ProfileRunSportTag.vue?vue&type=template&id=1d38def4&"
import script from "./ProfileRunSportTag.vue?vue&type=script&lang=ts&"
export * from "./ProfileRunSportTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports